import React, { useState, useRef, useEffect } from "react";
import "./titleButton.css";

export default function TitleButton({
  title,
  flagSrc,
  checklist,
  tasks
}) {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handler = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const exportChecklist = () => {
    if (!checklist || !tasks?.length) {
      alert("No checklist selected");
      return;
    }

    const headers = ["Task", "Time", "Items", "Comments"];
    const rows = tasks.map(task => [
      task.Task,
      task.Time,
      task.Items,
      task.Comments
    ]);

    const csvContent = [
      headers.join(","),
      ...rows.map(r => r.map(v => `"${v ?? ""}"`).join(","))
    ].join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = `income-checklist-${checklist.formattedDate}.csv`;
    link.click();

    URL.revokeObjectURL(url);
    setOpen(false);
  };

  return (
    <div className="title-button-header">
      <h1 className="title-button-title">
        <img
          src={flagSrc}
          alt="Income Team Flag"
          className="title-button-flag"
        />
        <span className="title-button-text">{title}</span>
      </h1>

      <div className="title-button-actions" ref={dropdownRef}>
        <button
          className="title-button-actions-btn"
          onClick={() => setOpen(prev => !prev)}
        >
          Actions ▾
        </button>

        {open && (
          <div className="title-button-dropdown">
            <button
              className="title-button-dropdown-item"
              onClick={exportChecklist}
              disabled={!checklist}
            >
              Export checklist
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
